import { Edit03Icon, PlusIcon } from '@langchain/untitled-ui-icons';
import { Button } from '@mui/joy';

import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { AnnotationQueuesTable } from '@/Pages/AnnotationQueue/AnnotationQueuesTable';
import { AnnotationQueueCrudPane } from '@/components/AnnotationQueuePopover/AnnotationQueueCrudPane';
import EmptyState from '@/components/EmptyState';
import { appAnnotationQueuesPath } from '@/utils/constants';

import { DEFAULT_PAGINATION_MODEL } from '../constants';

function CreateAnnotationQueue() {
  const navigate = useNavigate();
  const [createOpen, setCreateOpen] = useState(false);
  return (
    <>
      <Button
        color="primary"
        size="sm"
        onClick={() => {
          setCreateOpen(true);
        }}
        startDecorator={<PlusIcon className="size-4" />}
      >
        New queue
      </Button>
      <AnnotationQueueCrudPane
        open={createOpen}
        closeModal={() => setCreateOpen(false)}
        onSuccess={(aq) => {
          navigate(`${appAnnotationQueuesPath}/${aq.id}`);
        }}
      />
    </>
  );
}

export function HomeAnnotationQueuesTable() {
  return (
    <AnnotationQueuesTable
      simple={true}
      defaultPaginationModel={DEFAULT_PAGINATION_MODEL}
      emptyState={
        <div className="p-4">
          <EmptyState
            title="No annotation queues found"
            description="Create a new annotation queue and add runs to it"
            action={<CreateAnnotationQueue />}
            fancyIcon={true}
            icon={<Edit03Icon />}
          />
        </div>
      }
    />
  );
}
